export const api = {
  baseURL: process.env.REACT_APP_API_BASE_URL || window.location.origin,
};
